"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.includesByProperty = void 0;
function includesByProperty(arr, key, value) {
    return arr.find(function (obj) { return obj[key] === value; }) != null;
}
exports.includesByProperty = includesByProperty;
